import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const MoveTemplateModal = ({ show, toggleShow, template, categories = [], onMove }) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  useEffect(() => {
    if (show) {
      // default to current template category or empty (No Category)
      setSelectedCategoryId(template?.templateCategoryId ?? "");
    }
  }, [show, template]);

  const handleConfirm = () => {
    if (onMove) {
      onMove({ id: template.id, templateCategoryId: selectedCategoryId === null ? "" : selectedCategoryId });
    }
  };

  return (
    <Modal show={show} onHide={toggleShow} centered>
      <Modal.Header closeButton>
        <Modal.Title>Move {template?.templateName ?? "Template"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Select Category (select "No Category" to remove)</Form.Label>
          <Form.Select value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)}>
            <option value="">No Category</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggleShow}>Cancel</Button>
        <Button variant="primary" onClick={handleConfirm}>Move</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveTemplateModal;
